export default __webpack_public_path__ + "a3320ce0738421e20cb13107e11e6fcc.png";